// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/cms/sass/cms.scss
// module id = ./resources/assets/cms/sass/cms.scss
// module chunks = 1